import * as React from 'react'
import * as R from 'ramda'
import StackGrid from 'react-stack-grid'
import * as InfiniteScroll from 'react-infinite-scroller'
import Thumbnail from 'components/Thumbnail'
import { getPhotoCol } from 'fb'

const cloudinaryBaseResourceUrl = '//res.cloudinary.com/kanziw/image/upload'

export default class extends React.Component {
  private aWidth = 300
  private gutter = 10
  private limit = 12
  private hasMore = true
  private isSubscribing = false

  private subscribeNewPhotos() {
    this.isSubscribing = true

    return getPhotoCol()
      .orderBy('createdAt', 'desc')
      .where('createdAt', '>', Date.now())
      .onSnapshot(snapshot => {
        const thumbnails = snapshot.docChanges()
          .filter(R.propEq('type', 'added'))
          .map(change => change.doc)
        this.addThumbnailsFirst(thumbnails)
      })
  }

  private getNextQuery(): Query {
    return getPhotoCol()
      .orderBy('createdAt', 'desc')
      .startAfter(R.last(this.state.thumbnails) || {})
      .limit(this.limit + 1)
  }

  private async addOlderPhotos() {
    const querySnapshot = await this.getNextQuery().get()
    const thumbnails = [ ...querySnapshot.docs ]
    if (querySnapshot.size > this.limit) {
      this.hasMore = true
      thumbnails.pop()
    } else {
      this.hasMore = false
    }
    this.addThumbnailsLast(thumbnails)

    if (!this.isSubscribing) { this.subscribeNewPhotos() }
  }

  private addThumbnailsFirst = (thumbnails: QueryDocumentSnapshot[]): void => {
    this.setState({ thumbnails: [ ...thumbnails, ...this.state.thumbnails ] })
  }

  private addThumbnailsLast = (thumbnails: QueryDocumentSnapshot[]): void => {
    this.setState({ thumbnails: [ ...this.state.thumbnails, ...thumbnails ] })
  }

  private mapSnapshotToImageObject = (doc: QueryDocumentSnapshot): ThumbnailObject => {
    const { idPrefix, url, width, height, tags } = doc.data()
    const aHeight = Math.ceil((height * this.aWidth) / width)
    const thmUrl300 =
      `${cloudinaryBaseResourceUrl}/w_${this.aWidth}/v1533357483/${idPrefix}/${doc.id}.jpg`
    return { id: doc.id, url, thmUrl300, height: aHeight, tags }
  }

  public state: { thumbnails: QueryDocumentSnapshot[] } = { thumbnails: [] }

  private drawThumbnailList = () => this.state.thumbnails.map(doc => {
    const { id, thmUrl300, height, tags } = this.mapSnapshotToImageObject(doc)
    return <Thumbnail key={id} src={thmUrl300} height={height} id={id} tags={tags} />
  })

  private requestMorePhotos = this.addOlderPhotos.bind(this)

  public render() {
    return (
      <InfiniteScroll hasMore={this.hasMore} loadMore={this.requestMorePhotos} threshold={20}>
        <StackGrid columnWidth={this.aWidth} gutterWidth={this.gutter} gutterHeight={this.gutter}>
          {this.drawThumbnailList()}
        </StackGrid>
      </InfiniteScroll>
    )
  }
}

export interface ThumbnailObject extends DocumentData {
  id: string
  tags: string[]
  url: string
  thmUrl300: string
  height: number
}

import * as firebase from 'firebase'
import QueryDocumentSnapshot = firebase.firestore.QueryDocumentSnapshot
import Query = firebase.firestore.Query
import DocumentData = firebase.firestore.DocumentData



// WEBPACK FOOTER //
// ./src/containers/ThumbnailList/index.tsx